import React from 'react';
import TrailBlazerWinners2025 from 'views/TrailBlazerWinners2025';


const TheNPSFamilyPage = () => {
  return <TrailBlazerWinners2025/>;
};

export default TheNPSFamilyPage;